"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaTurma = exports.yupTurma = void 0;
const yup = __importStar(require("yup"));
const turno_1 = require("../enums/turno");
exports.yupTurma = yup.object({
    idCurso: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .label('Curso'),
    idSerie: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .label('Serie'),
    idMatrizCurricular: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Matriz Curricular'),
    turma: yup.string().default('').max(3).required().label('Turma'),
    tituloTurma: yup.string().default('').max(30).required().label('Titulo Turma'),
    codigoInep: yup.string().default('').max(10).label('Codigo Inep'),
    turno: yup.mixed().oneOf(Object.values(turno_1.ETurno)).required().default(turno_1.ETurno.Manha).label('Turno'),
    chamadaFixada: yup.boolean().required().default(false).label('Chamada Fixada'),
    sala: yup.string().default('').max(4).label('Sala'),
    limiteSala: yup.number().default(0).integer().label('Limite da Sala'),
    numeroFileira: yup.number().default(0).integer().label('Número de Fileira na Sala'),
    numeroCarteira: yup.number().default(0).integer().label('Número de Carteira na Sala'),
    totalMatriculado: yup.number().default(0).integer().label('Número de Aluno Matriculado'),
    totalEstudando: yup.number().default(0).integer().label('Número de Aluno Estudando'),
    totalDesistente: yup.number().default(0).integer().label('Número de Aluno Desistente'),
    totalTransferido: yup.number().default(0).integer().label('Número de Aluno Transferido'),
    encerrada: yup.boolean().required().default(false).label('Turma Encerrada'),
    naoReprovar: yup.boolean().required().default(false).label('Não Reprovar Alunos dessa Turma'),
    imprimirMencao: yup.boolean().required().default(false).label('Imprimir Menção'),
    observacaoDiario: yup.string().default('').max(400).label('Observação do Diario de Classe'),
    observacaoHistorico: yup.string().default('').max(400).label('Observação do Histórico Escolar'),
    //Financeiros
    valorDiferenciado: yup.boolean().default(false).label('Valores diferenciados'),
    valorAtual: yup.number().notRequired().label('Valor para alunos atuais'),
    valorNovo: yup.number().notRequired().label('Valor para alunos novos'),
    valorEntradaAtual: yup.number().notRequired().label('Valor da entrada para alunos atuais'),
    valorEntradaNovo: yup.number().notRequired().label('Valor da entrada alunos novos'),
    valorMaterialAtual: yup.number().notRequired().label('Valor da material para alunos atuais'),
    valorMaterialNovo: yup.number().notRequired().label('Valor da material alunos novos'),
    descontoPagamentoDia: yup.boolean().default(false).label('Desconto para pagamento em dia'),
    valorDesconto: yup.number().notRequired().label('Valor do desconto'),
    descontoPercentual: yup.boolean().default(false).label('Desconto em percentual'),
});
exports.schemaTurma = exports.yupTurma.shape({});
